<template>
  <div class="flex justify-center items-center p-6 min-h-screen bg-indigo-800">
    <div class="w-full max-w-lg">
      <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
      <h5 class="pt-2 text-xl font-bold text-center text-white">
        Sistem Aplikasi Penyaluran Beasiswa Kabupaten Puncak Papua
      </h5>
      <form
        class="overflow-hidden mt-4 bg-white rounded-lg shadow-xl"
        @submit.prevent="login">
        <div class="py-12 px-10">
          <h1 class="text-3xl font-bold text-center">
            PENGUMUMAN
          </h1>
          <div class="mx-auto mt-4 w-24 border-b-2" />
          <div class="mt-4 -mb-6 text-sm text-justify">
            <p class="mb-2">
              Diberitahukan Kepada Seluruh Mahasiswa/i Penerima Beasiswa Akhir
              Studi bahwa telah selesainya Penginputan Data, Verifikasi dan
              Penyaluran Beasiswa Akhir Studi, maka bersama ini Portal Aplikasi
              SAPBKPP <b>Akhir Studi ditutup.</b>
            </p>
            <p class="mb-2">
              Portal Aplikasi SAPBKPP Beasiswa akan dibuka pada bulan
              <b>Juli 2025</b> bagi Mahasiswa/i Aktif Kuliah.
            </p>
            <p>Demikian Pemberitahuan ini disampaikan, terima kasih.</p>
          </div>
          <text-input
            v-model="form.userid"
            autocomplete="username"
            :error="form.errors.userid"
            class="mt-10"
            label="Email / No.Rekening"
            type="text"
            autofocus
            autocapitalize="off" />
          <text-input
            v-model="form.password"
            autocomplete="current-password"
            :error="form.errors.password"
            class="mt-6"
            label="Password"
            type="password" />
        </div>
        <div class="flex py-4 px-10 bg-gray-100 border-t border-gray-100">
          <inertia-link
            v-if="$page.props.register_enabled"
            class="px-2 text-indigo-400 hover:text-indigo-600"
            :href="route('register.index')">
            Register
          </inertia-link>
          <loading-button
            :loading="form.processing"
            class="ml-auto btn-indigo"
            type="submit">
            Login
          </loading-button>
        </div>
        <div
          class="flex justify-center items-center py-4 px-10 bg-gray-100 border-t border-gray-100">
          Lupa password anda? silahkan klik
          <inertia-link
            class="pr-2 pl-1 text-indigo-400 hover:text-indigo-600"
            :href="route('password.request')">
            disini
          </inertia-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link } from '@inertiajs/vue2'

export default {
  metaInfo: { title: 'Login' },
  components: {
    LoadingButton,
    Logo,
    TextInput,
    'inertia-link': Link,
  },
  data () {
    return {
      form: this.$inertia.form({
        userid: null,
        password: null,
        remember: false,
      }),
    }
  },
  methods: {
    login () {
      this.form.post(this.route('login.store'))
    },
  },
}
</script>
